import { useContext } from "react";

import urlTransformerContext from "./urlTransformerContext";

export default function useUrlTransformer() {
  return useContext(urlTransformerContext);
}
